import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_OTHER_ALLOWANCES:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.FETCH_OTHER_ALLOWANCE:
      return { ...state, [action.payload.Id]: action.payload };
    case type.CREATE_OTHER_ALLOWANCE:
      return { ...state, [action.payload.Id]: action.payload };
    case type.EDIT_OTHER_ALLOWANCE:
      return { ...state, [action.payload.Id]: action.payload };
    case type.CLEAR_OTHER_ALLOWANCE:
      return [];
    case type.DELETE_OTHER_ALLOWANCE:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
